<template>
	<span class="Count">{{ countFormatted }}</span>
</template>

<script>
export default {
	name: 'Count',
	components: {},
	props: {
		count: {
			type: Number,
			required: true,
		},
		locale: {
			type: String,
			default: 'en-US',
		}
	},
	computed: {
		countFormatted() {
			if (this.count === 0) {
				return "X";
			} else if (this.count.toString().length >= 5) {
				return new Intl.NumberFormat(this.locale).format(this.count);
			} else {
				return this.count;
			};
		},
	},
};
</script>

<style lang="scss">
	.Count {
		display: inline-block;
		min-width: 3ch;
		min-width: min(var(--maxCountWidth, 3ch), 4ch);
		text-align: right;
		[dir='rtl'] & {
			text-align: left;
		}
		font-weight: bold;
		@include breakpoint(medium) {
			min-width: var(--maxCountWidth, 3ch);
		}
	}
</style>
